module.exports = __webpack_public_path__ + "media/bowser.96880cae.wav";